import { Flex, IconSmileys18, ShapeIcons, Typography } from '@creditas-ui/react';
import type { JSX } from 'react';
import type { FeedbackSchema } from '~/shared/domain/models/feedback';

type Props = {
  data: FeedbackSchema;
};

type Component = (props: Props) => JSX.Element;

export const Feedback: Component = ({ data: { title, subtitle } }) => {
  return (
    <Flex flexDirection="column" alignItems="flex-start" spaceY="32px">
      <ShapeIcons Icon={IconSmileys18} size="x_small" data-testid="icon-sad" />
      <Typography
        variant={{ _: 'headingSmLight', '3xl': 'headingMdLight' }}
        color="neutral.90"
        maxWidth="300px"
      >
        {title}
      </Typography>
      <Typography variant="bodyMdRegular" color="neutral.60" maxWidth="350px">
        {subtitle}
      </Typography>
    </Flex>
  );
};
